module.exports = __webpack_public_path__ + "static/media/reform_health_horiz_300.a41769e2.png";